module.exports = __webpack_public_path__ + "static/media/rs.d00d37d2.svg";